const size={mobile:'1024px'// 1024px
};export const device={mobile:"(max-width: ".concat(size.mobile,")"),desktop:"(min-width: ".concat(size.mobile,")")};